import { strToThousands, stripscript } from '@/utils/utils'
import store from '@/store'

import {
  generateTableHtml,
  tableHtmlWrapper,
  generateDescriptionHtml
} from '@/utils/generate-html'
import { watermarkTypeDict } from '@/dictionary/template'
import nzhcn from 'nzh/cn'
import {
  workflowAuditCheckDict,
  workflowAuditStatusDict
} from '@/dictionary/workflow'

import {
  getFileUrlByFileIdApi,
  htmlToPdfApi,
  getFileListByFileIdsApi,
  getFileListByGroupIdApi
} from '@/api/up-file'
// 招标采购相关字典及api
import {
  fetchInviteBidDetailApi,
  fetchCandidateApi,
  fetchWinBidApi
} from '@/api/procure/invite-bid'
import { exportInquiryWinnerApi } from '@/api/procure/inquiry'

// 字典
import {
  isComboDict,
  bidWinWayDict,
  needBidBondDict,
  bidInviteWayDict,
  bidPublishWayDict,
  bidRegisterAuditFlagDict,
  uploadBiddingFileTypeDict,
  bidPublishAuctionDict,
  bidAuctionStatusDict
} from '@/dictionary/project/bid'
import {
  whetherDict,
  projectTypeDict,
  projectOpenScopeDict,
  otherMaterialTypeDict,
  otherMaterialRequirementDict,
  flowMarkDict,
  whetherSignatureDict,
  offerTypeDict,
  currencyTypeDict
} from '@/dictionary/project/common'
import {
  getAuctionByIdApi,
  getClarificationByIdApi,
  getChangeInfoByIdApi
} from '@/api/procure/invite-bid'

import {
  getWorkflowAuditWorkflowDetailApi,
  getWorkflowRemarksApi
} from '@/api/workflow'

// 询比相关api
import {
  getInquiryOrderApi,
  inquiryAbortiveInfoApi,
  getNewestCandidateInfoApi,
  getNewestWinnerInfoApi,
  getNewestChangeInfoApi
} from '@/api/procure/inquiry'

// 自定义字段字典
import {
  materialTemplateDefineTypeDict,
  materialColumnTypeDict
} from '@/dictionary/material/template'

import { inquiryWhetherToPublishDict } from '@/dictionary/project/inquiry'

import {
  inquiryAllowPartDict,
  inquiryRequireTaxDict,
  inquiryProcureTypeDict,
  inquiryWayDict,
  inquiryNeedReviewDict,
  inquiryCompareWayDict
} from '@/dictionary/project/inquiry'
import { round } from 'lodash'

// 金额大写
function moneyInCn(money, multiple = 1) {
  // 去除千分位
  const moneyWithoutThousand = money?.toString()?.replace(/\,/g, '')
  // 将金额转换为数字
  const moneyNumber = parseFloat(moneyWithoutThousand)

  // 判断money转换后是否为数字
  if (isNaN(moneyNumber)) {
    return ''
  }

  const realMoney = (moneyNumber * multiple).toString()
  return (
    '大写：' + nzhcn.toMoney(parseFloat(realMoney || '0'), { outSymbol: false })
  )
}

// 富文本处理
function richText(content) {
  if (content) {
    content = content.replace(/(\n)/g, '')
    content = content.replace(/(\t)/g, '')
    content = content.replace(/(\r)/g, '')
    content = content.replace(/<\/?[^>]*>/g, '')
    return content
  }
  return ''
}

// 询比自定义字段模板处理
function setColumnConfig(defineList) {
  const columnConfig = (defineList || []).map(item => {
    return {
      columnName: item.columnName,
      // 字段类型为品目名称的或自定义的，均可以修改名称
      canEditColumnName:
        item.columnType === materialColumnTypeDict.NAME.value ||
        item.columnType === materialColumnTypeDict.CUSTOM.value,
      defineType: item.defineType,
      defineCode: item.defineCode,
      supplierRequire: item.supplierRequire,
      supplierVisible: item.supplierVisible,
      enable: item.isEnable === 1,
      isEnable: item.isEnable,
      columnType: item.columnType,
      // 字段类型为参数型号或自定义的，可以设置是否启用
      canEditEnable:
        item.columnType === materialColumnTypeDict.CUSTOM.value ||
        item.columnType === materialColumnTypeDict.MODEL.value
    }
  })
  return columnConfig
}
// 品目列表处理
async function materielListHandle(
  materielList,
  purchaseSpecifyConfig,
  supplierResponseConfig
) {
  const tableBody = []
  if (!materielList || !materielList.length) {
    return
  }
  for (let i = 0; i < materielList.length; i++) {
    const fileNameArr = []
    // 获取附件文件名
    if (
      materielList[i].attachmentFileIds &&
      materielList[i].attachmentFileIds.length
    ) {
      for (let j = 0; j < materielList[i].attachmentFileIds.length; j++) {
        const _FileData = await getFileListByFileIdsApi({
          attachmentId: materielList[i].attachmentFileIds[j]
        })
        fileNameArr.push(_FileData.data[0].attachmentInfo.fileName)
      }
    }
    const arr = [
      { content: i + 1 },
      {
        content: [
          `编码：${materielList[i]?.materielCode}` || '-',
          `品目名称：${materielList[i]?.materielName}` || '-',
          `分类：${
            materielList[i]?.categoryNameTree &&
            materielList[i]?.categoryNameTree?.length
              ? materielList[i].categoryNameTree.join('、')
              : '-'
          }`
        ],
        style: 'text-align: left;'
      },
      {
        content:
          `${materielList[i]?.materielNum}/${materielList[i]?.unitType}` || '-'
      },
      {
        content: materielList[i]?.materielModel || '-'
      },
      {
        content: [
          {
            content: materielList[i]?.budgetUnitPrice
              ? strToThousands(materielList[i]?.budgetUnitPrice)
              : '-'
          },
          {
            content: `${moneyInCn(materielList[i]?.budgetUnitPrice)}`,
            style: 'color: red;'
          }
        ],
        style: 'text-align: left;'
      },
      {
        content: [
          {
            content: materielList[i]?.totalPrice
              ? strToThousands(materielList[i]?.totalPrice)
              : '-'
          },
          {
            content: `${moneyInCn(materielList[i]?.totalPrice)}`,
            style: 'color: red;'
          }
        ],
        style: 'text-align: left;'
      },
      // 采购人指定
      {
        content: purchaseSpecifyConfig.map(
          p =>
            `${p.columnName}：${
              materielList[i][p?.defineCode]
                ? materielList[i][p?.defineCode]
                : '-'
            }`
        ),
        style: 'text-align: left;'
      },
      // 供应商指定
      {
        content: supplierResponseConfig.map(
          p =>
            `${p.columnName}：${materielList[i][p?.defineCode] ||
              '供应商响应，无需填写'}`
        ),
        style: 'text-align: left;'
      },
      {
        content: materielList[i]?.remarks || '-'
      },
      {
        content: materielList[i]?.insideRemark || '-'
      },
      {
        content: fileNameArr.join('、') || '-'
      }
    ].filter(value => value)
    tableBody.push(arr)
  }

  return tableBody
}

function setTableConfig(columnConfig) {
  const materielInfoConfig = []
  const purchaseSpecifyConfig = []
  const supplierResponseConfig = []

  columnConfig.forEach(item => {
    // 获取品目名称和品目编码的字段配置
    if (
      item.columnType === materialColumnTypeDict.NAME.value ||
      item.columnType === materialColumnTypeDict.CODE.value
    ) {
      materielInfoConfig.push(item)
    }
    // 获取供应商响应且已启用的字段配置
    if (
      item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
      item.isEnable
    ) {
      supplierResponseConfig.push(item)
    }
    // 获取采购人指定且已启用的字段配置
    if (
      item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
      item.isEnable
    ) {
      purchaseSpecifyConfig.push(item)
    }
  })

  // 由于模板中不存在分类的定义，需要手动添加分类
  materielInfoConfig.push({
    defineCode: 'categoryId',
    columnName: '分类'
  })
  return { materielInfoConfig, purchaseSpecifyConfig, supplierResponseConfig }
}

export function exportPDF(
  businessInfo,
  orderId,
  workflowId,
  requestQuery,
  isWuling
) {
  if (businessInfo.businessType === 'bidding') {
    // 招标-采购公告
    if (businessInfo.businessNode == 'release_purchase_notice') {
      bidProcurement(orderId, workflowId)
    }

    // 招标-邀请函
    if (businessInfo.businessNode == 'release_invitation_letter') {
      bidInvitation(orderId, workflowId)
    }

    // 招标-变更公告
    if (businessInfo.businessNode == 'release_change_notice') {
      bidChange(orderId, requestQuery, workflowId)
    }

    // 招标-文件澄清
    if (businessInfo.businessNode == 'release_supplement_file') {
      bidClarify(businessInfo, orderId, workflowId)
    }

    // 招标-候选公示
    if (businessInfo.businessNode == 'submit_confirm_candidate_supplier') {
      bidCandidate(orderId, requestQuery, workflowId)
    }

    // 招标-成交结果
    if (businessInfo.businessNode == 'submit_confirm_winner_supplier') {
      bidClinch(orderId, requestQuery, workflowId)
    }

    // 招标-流标公告
    if (businessInfo.businessNode == 'submit_close') {
      bidLoss(orderId, requestQuery, workflowId)
    }
  }
  if (businessInfo.businessType === 'inquiry') {
    // 询比-采购公告
    if (businessInfo.businessNode == 'release_purchase_notice') {
      inquiryProcurement(orderId, requestQuery, workflowId)
    }

    // 询比-邀请函
    if (businessInfo.businessNode == 'release_invitation_letter') {
      inquiryInvitation(orderId, requestQuery, workflowId)
    }

    // 询比-变更公告
    if (businessInfo.businessNode == 'release_change_notice') {
      inquiryChange(orderId, requestQuery, workflowId)
    }

    // 询比-候选公示
    if (businessInfo.businessNode == 'submit_confirm_candidate_supplier') {
      inquiryCandidate(orderId, requestQuery, workflowId, isWuling)
    }

    // 询比-成交结果
    if (businessInfo.businessNode == 'submit_confirm_winner_supplier') {
      inquiryClinch(orderId, requestQuery, workflowId, isWuling)
    }

    // 询比-流标公告
    if (businessInfo.businessNode == 'submit_close') {
      inquiryLoss(orderId, requestQuery, workflowId)
    }
  }
}

// 招标信息
function bidInfoDescription(orderInfo, pdfTitle) {
  const desc = generateDescriptionHtml({
    pdfTitle: pdfTitle,
    descriptionTitle: {
      content: '招标信息'
    },
    descriptionContent: [
      {
        label: '招标名称',
        content: orderInfo?.orderName || '-'
      },
      {
        label: '招标估算',
        content: [
          {
            content: (strToThousands(orderInfo?.budget) || '-') + '万元'
          },
          {
            content: moneyInCn(orderInfo?.budget, 10000),
            contentStyle: 'color: red'
          }
        ]
      },
      {
        label: '中标方式',
        content: bidWinWayDict.translate(orderInfo?.winType).label || '-'
      },
      {
        label: '报价方式',
        content: offerTypeDict.translate(orderInfo?.offerType).label || '-'
      },
      {
        label: '报名时间',
        content: `${orderInfo?.signUpStartTime ||
          '-'}~${orderInfo?.signUpEndTime || '-'}`
      },
      {
        label: '开标时间',
        content: orderInfo?.openTime || '-'
      },
      {
        label: '项目类型',
        content: projectTypeDict.translate(orderInfo?.biddingType).label || '-'
      },
      {
        label: '发布媒体',
        content: orderInfo?.noticeMedium || '-'
      },
      {
        label: '招标地点',
        content:
          `${orderInfo?.country}/${orderInfo?.province}/${orderInfo?.city}/${orderInfo?.area}` ||
          '-'
      },
      {
        label: '详细地址',
        content: orderInfo?.detailAddress || '-'
      }
    ]
  })
  return desc
}

// 处理审批记录
function auditHistoryHandle(recordList) {
  const auditHistoryDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '审批记录'
    }
  })
  const auditHistoryList = []
  const workflowBusinessObject = store.state.workflow.workflowBusinessObject
  if (recordList && recordList.length) {
    recordList.forEach(item => {
      let obj = {}
      if (item.status == 4) {
        obj = {
          initiatorName: item?.initiatorName,
          endTime: item?.endTime,
          workflowType: `${workflowBusinessObject[item.businessType]}/${
            workflowBusinessObject[item.businessNode]
          }`,
          executorInfo: `${item.initiatorName}(${
            workflowAuditCheckDict.translate(item.status).label
          })`,
          status: item.status,
          workflowId: item.workflowId
        }
      } else {
        const executorInfo = []
        if (item?.currentTaskList && item?.currentTaskList.length) {
          item.currentTaskList.map(val => {
            const str = `${val?.executorName}(${
              workflowAuditStatusDict.translate(val?.reviewResult).label
            })`
            executorInfo.push(str)
          })
        }
        obj = {
          initiatorName: item.initiatorName,
          endTime: item.endTime,
          workflowType: `${workflowBusinessObject[item.businessType]}/${
            workflowBusinessObject[item.businessNode]
          }`,
          executorInfo: executorInfo.join(','),
          status: item.status,
          workflowId: item.workflowId
        }
      }
      auditHistoryList.push(obj)
    })
  }

  const tableHead = [
    { content: '序号', width: '30px' },
    { content: '审批完成时间', width: '120px' },
    { content: '审批类型', width: '30px' },
    { content: '发起人', width: '100px' },
    { content: '审批信息', width: '100px' },
    { content: '审批结果', width: '100px' }
  ]
  let tableBody = []
  if (auditHistoryList && auditHistoryList.length) {
    tableBody = auditHistoryList.map((value, index) => {
      return [
        { content: index + 1 },
        { content: value.endTime || '-' },
        { content: value.workflowType || '-' },
        {
          content: value.initiatorName || '-'
        },
        {
          content: value.executorInfo || '-'
        },
        {
          content: workflowAuditCheckDict.translate(value.status).label || '-'
        }
      ].filter(value => value)
    })
  }
  const auditHistoryTableHtml = generateTableHtml({
    pdfTitle: '',
    describeInfoTop: [],
    tableHead: { fixedPrev: tableHead },
    tableData: tableBody,
    needHtmlWrapper: false,
    needPageWrapper: false
  })

  return { auditHistoryDesc, auditHistoryTableHtml }
}

// 询比单信息
function inquiryDescription(orderInfo, pdfTitle) {
  const desc = generateDescriptionHtml({
    pdfTitle: pdfTitle,
    descriptionTitle: {
      content: '询比单信息'
    },
    descriptionContent: [
      {
        label: '询比单名称',
        content: orderInfo?.orderName || '-'
      },
      {
        label: '询比单编号',
        content: orderInfo?.orderCode || '-'
      },
      {
        label: '项目类型',
        content: projectTypeDict.translate(orderInfo?.projectType).label || '-'
      },
      {
        label: '收货地址',
        span: 1,
        content:
          `${orderInfo?.address?.receivingCountry}/${orderInfo?.address?.receivingProvince}/${orderInfo?.address?.receivingCity}/${orderInfo?.address?.receivingArea}` ||
          '-'
      },
      {
        label: '详细地址',
        span: 2,
        content: orderInfo?.address?.address || '-'
      }
    ]
  })
  return desc
}

// 计算品目总金额
function getTotalFee(materialList) {
  let fee = 0
  let totalFee = 0
  if (materialList.length === 0) {
    return totalFee
  }

  materialList.forEach(val => {
    fee = fee + Number(val.totalPrice) * 100
  })
  totalFee = fee / 100
  return totalFee
}

/**
 * 非含税成交总价
 */
function getResultNoRateTotalPrice(row) {
  if (row.num && row.noRateOfferPrice) {
    const num = Number(row.num || 0) * 100
    const price = Number(row.noRateOfferPrice || 0) * 100
    const result = (num * price) / 10000
    return isNaN(result) ? '' : round(result, 2).toFixed(2)
  }
  return ''
}

/**
 * 含税成交总价
 */
function getResultTotalPrice(row) {
  let offerPrice = ''
  const requireTax = Boolean(row.offerTaxRate)
  if (requireTax) {
    // 如果报价含税，则供应商报价为noRateOfferPrice
    offerPrice = row.noRateOfferPrice
    const num = Number(row.num || 0) * 100
    const price = Number(offerPrice || 0) * 100
    const rate = 100 + Number(row.offerTaxRate || 0)
    const result = (num * price * rate) / 1000000
    return isNaN(result) ? '' : round(result, 2).toFixed(2)
  } else {
    // 如果报价不含税，则供应商报价为offerPrice
    offerPrice = row.offerPrice
    const num = Number(row.num || 0) * 100
    const price = Number(offerPrice || 0) * 100
    const result = (num * price) / 10000
    return isNaN(result) ? '' : round(result, 2).toFixed(2)
  }
}

// 候选品目取消
async function getCandidateCancelHtmlData({
  cancelList = [],
  cancelReason = '',
  cancelAttachmentIds = [],
  isDollar = false,
  itemSchemaList = []
}) {
  // 表格模板处理
  const columnConfig = setColumnConfig(itemSchemaList)
  const { purchaseSpecifyConfig, materielInfoConfig } = setTableConfig(
    columnConfig
  )

  const materieltableHeader = [
    { content: '序号', width: '20px' },
    { content: '品目信息', width: '200px' },
    { content: '采购量/单位', width: '60px' },
    { content: `预算单价(${isDollar ? '美元' : '元'})`, width: '60px' },
    { content: `预算总价(${isDollar ? '美元' : '元'})`, width: '60px' },
    { content: '采购人指定', width: '200px' },
    { content: '报价供应商数量', width: '200px' }
  ]
  const materieltableBody = cancelList.map((value, index) => {
    return [
      { content: index + 1 },
      {
        content: materielInfoConfig.map(m => {
          return `${m.columnName}：${value[m.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      {
        content: (value.materielNum || '-') + '/' + (value.unitType || '-')
      },
      {
        content: strToThousands(value.budgetUnitPrice) || '-'
      },
      { content: strToThousands(value.totalPrice) || '-' },
      {
        content: purchaseSpecifyConfig.map(p => {
          return `${p.columnName}：${value[p.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      {
        content: value.supplierNum || 0,
        style: 'text-align: left;'
      }
    ].filter(value => value)
  })

  let attachmentList = []
  try {
    const res = await getFileListByFileIdsApi({
      attachmentId: cancelAttachmentIds.join(',')
    })
    attachmentList = res.data || []
  } catch (e) {
    //
  }

  return generateTableHtml({
    tableHead: { fixedPrev: materieltableHeader },
    tableData: materieltableBody,
    describeInfoBottom: [
      [{ label: '取消采购原因', content: cancelReason || '-' }],
      [
        {
          label: '说明文件',
          content:
            attachmentList
              .map(value => value?.attachmentInfo?.fileName || value?.fileKey)
              .join(', ') || '-'
        }
      ]
    ],
    needHtmlWrapper: false
  })
}

// 供应商表格处理
async function supplierTableHandle(
  itemSchemaList,
  detailDtoList,
  title,
  isWuling
) {
  // 表格模板处理
  const columnConfig = await setColumnConfig(itemSchemaList)
  const {
    purchaseSpecifyConfig,
    supplierResponseConfig
  } = await setTableConfig(columnConfig)
  const candidateMaterielId = []
  const detailVoList = []
  detailDtoList.forEach(item => {
    // 未含税授标总价
    const resultNoRateTotalPrice = getResultNoRateTotalPrice(item)
    // 含税授标总价
    const resultTotalPrice = getResultTotalPrice(item)
    if (!candidateMaterielId.includes(item.materielId)) {
      candidateMaterielId.push(item.materielId)
      const itemCopy = JSON.parse(JSON.stringify(item))

      const obj = {
        supplierName: item.supplierName,
        offerTotalPrice: item.rateBargainTotalPrice || item.offerTotalPrice, // 含税总价
        noRateOfferPrice: item.isBargain
          ? item.bargainPrice
          : item.noRateOfferPrice, // 未含税价 noRateOfferPrice
        num: item.num, // 授标数量
        offerTaxRate: item.offerTaxRate, // 税率
        offerPrice: item.isBargain ? item.bargainPrice : item.offerPrice, // 含税价
        resultTotalPrice: isWuling
          ? item.isBargain
            ? item.bargainTotalPrice
            : resultNoRateTotalPrice
          : resultTotalPrice,
        offerDeliveryDay: item.offerDeliveryDay
      }
      itemCopy.supplierList = []
      itemCopy.supplierList.push(obj)
      detailVoList.push(itemCopy)
    } else {
      detailVoList.map(dataItem => {
        if (dataItem.materielId == item.materielId) {
          const obj = {
            supplierName: item.supplierName,
            offerTotalPrice: item.rateBargainTotalPrice || item.offerTotalPrice, // 含税总价
            noRateOfferPrice: item.isBargain
              ? item.bargainPrice
              : item.noRateOfferPrice, // 未含税价 noRateOfferPrice
            num: item.num, // 授标数量
            offerTaxRate: item.offerTaxRate, // 税率
            offerPrice: item.offerPrice, // 含税总价
            resultTotalPrice: isWuling
              ? item.isBargain
                ? item.bargainTotalPrice
                : resultNoRateTotalPrice
              : resultTotalPrice,
            offerDeliveryDay: item.offerDeliveryDay
          }
          dataItem.supplierList.push(obj)
        }
      })
    }
  })
  const materieltableHeader = [
    [
      { content: '采购信息', colspan: 5 },
      { content: title, colspan: 4 }
    ],
    [
      { content: '序号', width: '80px' },
      { content: '品目信息', width: '200px', style: 'text-align: left;' },
      { content: '价格', width: '100px', style: 'text-align: left;' },
      { content: '授标数量', style: 'text-align: left;' },
      { content: '采购人指定', width: '200px', style: 'text-align: left;' },
      { content: '供应商名称', width: '200px', style: 'text-align: left;' },
      { content: '供应商响应', width: '200px', style: 'text-align: left;' },
      { content: '报价信息', width: '140px', style: 'text-align: left;' },
      { content: '授标数量', width: '50px', style: 'text-align: left;' }
    ]
  ]

  const materieltableBody = detailVoList.map((value, index) => {
    const data = []
    value.supplierList.map(item => {
      const arr = [
        { content: 1 + index }, // 序号
        // 品目信息
        {
          content: [
            `编码：${value.materielCode ? value.materielCode : '-'}`,
            `品目名称：${value.materielName ? value.materielName : '-'}`,
            `分类：${
              value.categoryNameTree && value.categoryNameTree.length
                ? value.categoryNameTree.join('、')
                : '-'
            }`,
            `采购量：${value.materielNum ? value.materielNum : '-'}`,
            `单位：${value.unitType ? value.unitType : '-'}`,
            `参数型号：${value.materielModel ? value.materielModel : '-'}`
          ],
          style: 'text-align: left;'
        },
        // 价格
        {
          content: [
            `预算单价(元)：${
              value.budgetUnitPrice
                ? strToThousands(value.budgetUnitPrice)
                : '-'
            }`,
            {
              content: `${moneyInCn(value.budgetUnitPrice)}`,
              style: 'color: red'
            },
            `预算总价(元)：${
              value.totalPrice ? strToThousands(value.totalPrice) : '-'
            }`,
            {
              content: `${moneyInCn(value.totalPrice)}`,
              style: 'color: red'
            }
          ],
          style: 'text-align: left;'
        },
        // 授标量
        { content: item.num, style: 'text-align: left;' },
        // 采购人指定
        {
          content: purchaseSpecifyConfig.map(p => {
            return `${p.columnName}：${value[p.defineCode] || '-'}`
          }),
          style: 'text-align: left;'
        },
        // 供应商名称
        { content: item.supplierName || '-', style: 'text-align: left;' },
        // 供应商响应
        {
          content: supplierResponseConfig.map(s => {
            return `${s.columnName}：${value[s.defineCode] || '-'}`
          }),
          style: 'text-align: left;'
        },
        // 报价信息
        {
          content: [
            {
              content: `未含税价(元)：${
                item.noRateOfferPrice
                  ? strToThousands(item.noRateOfferPrice)
                  : '-'
              } ${value.isBargain ? '（议）' : ''}`
            },
            {
              content: `${moneyInCn(item.noRateOfferPrice)}`,
              style: 'color: red;'
            },
            {
              content: `总价(元)：${
                item.resultTotalPrice
                  ? strToThousands(item.resultTotalPrice)
                  : '-'
              } ${value.isBargain ? '（议）' : ''}`
            },
            {
              content: `${moneyInCn(item.resultTotalPrice)} `,
              style: 'color: red;'
            }
          ].filter(value => value),
          style: 'text-align: left;'
        },
        // 授标数量
        { content: item.num, style: 'text-align: left;' }
      ]
      data.push(arr)
    })
    // console.log(data)
    return data
  })
  // 候选供应商
  const spplierTableHtml = generateTableHtml({
    pdfTitle: '',
    describeInfoTop: [],
    tableHead: { fixedPrev: materieltableHeader },
    tableData: materieltableBody.flat(),
    needHtmlWrapper: false,
    noFormat: true
  })
  return spplierTableHtml
}

// 询比 - 议价表格
async function generateBargainHtml(bargainInfo, isDollar) {
  if (bargainInfo.isBargain === whetherDict.NO.value) {
    return '<p>线下议价：否</p>'
  }

  const tableHeader = [
    { content: '序号', width: '80px' },
    { content: '品目名称', width: '200px', style: 'text-align: left;' },
    { content: '品目编码', width: '100px', style: 'text-align: left;' },
    { content: '数量', style: 'text-align: left;' },
    { content: '参数型号', width: '200px', style: 'text-align: left;' },
    { content: '品牌/制造商', width: '200px', style: 'text-align: left;' },
    { content: '供应商名称', width: '200px', style: 'text-align: left;' },
    {
      content: `议价不含税单价（${isDollar ? '美元' : '元'}）`,
      width: '140px',
      style: 'text-align: left;'
    },
    { content: '税率（%）', width: '50px', style: 'text-align: left;' },
    {
      content: `议价不含税总价（${isDollar ? '美元' : '元'}）`,
      width: '140px',
      style: 'text-align: left;'
    },
    {
      content: `议价含税总价（${isDollar ? '美元' : '元'}）`,
      width: '140px',
      style: 'text-align: left;'
    }
  ]
  const tableBody = (bargainInfo.bargainList || []).map((item, index) => [
    { content: `${index + 1}`, style: 'text-align: left;' },
    { content: item.materielName, style: 'text-align: left;' },
    { content: item.materielCode, style: 'text-align: left;' },
    { content: item.materielNum, style: 'text-align: left;' },
    { content: item.materielModel, style: 'text-align: left;' },
    { content: item.materielBrand, style: 'text-align: left;' },
    { content: item.supplierName, style: 'text-align: left;' },
    { content: item.bargainPrice, style: 'text-align: left;' },
    { content: item.offerTaxRate || '-', style: 'text-align: left;' },
    { content: item.bargainTotalPrice, style: 'text-align: left;' },
    { content: item.rateBargainTotalPrice, style: 'text-align: left;' }
  ])

  // 获取到附件名称
  let attachmentList = []
  try {
    const res = await getFileListByFileIdsApi({
      attachmentId: (bargainInfo.bargainAttachmentIds || []).join(',')
    })
    attachmentList = res.data || []
  } catch (e) {
    //
  }

  return generateTableHtml({
    tableHead: { fixedPrev: tableHeader },
    tableData: tableBody,
    describeInfoTop: [
      [{ label: '是否线下议价', content: '是' }],
      [
        {
          label: '线下议价记录',
          content:
            attachmentList
              .map(value => value?.attachmentInfo?.fileName || value?.fileKey)
              .join(', ') || '-'
        }
      ]
    ],
    needHtmlWrapper: false,
    needPageWrapper: false
  })
}

// 招标-采购公告
async function bidProcurement(orderId, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo.orderName
    ? orderInfo.orderName + '-' + '采购公告'
    : '采购公告'
  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)
  const requireList = []
  if (orderInfo.requireList && orderInfo.requireList.length) {
    orderInfo.requireList.map(item => {
      requireList.push(item.certName)
    })
  }

  // 招标方式
  const bidWayDescContent = [
    {
      label: '招标方式',
      content: bidInviteWayDict.translate(orderInfo?.biddingMethod).label || '-'
    },
    {
      label: '发布方式',
      content:
        bidPublishWayDict.translate(orderInfo?.releaseMethod).label || '-'
    },
    {
      label: '公开范围',
      content: projectOpenScopeDict.translate(orderInfo?.openScope).label || '-'
    },
    {
      label: '报名审核',
      content:
        bidRegisterAuditFlagDict.translate(orderInfo?.isApproval).label || '-',
      span: 1
    },
    {
      label: '证件要求',
      content: requireList.join('、') || '-',
      span: 2
    },
    {
      label: '备注',
      content: orderInfo?.approvalRemark || '-',
      span: 3
    },
    {
      label: '其他材料要求',
      content: '',
      span: 3
    }
  ]
  const orderSupplierCategoryList = []
  if (
    orderInfo.orderSupplierCategoryList &&
    orderInfo.orderSupplierCategoryList.length
  ) {
    orderInfo.orderSupplierCategoryList.map(item => {
      orderSupplierCategoryList.push(item.categoryName)
    })
  }
  const arr = {
    label: '已选范围',
    content: orderSupplierCategoryList.join('、') || '-',
    span: 3
  }
  if (orderInfo.openScope == 1) {
    bidWayDescContent.splice(3, 0, arr)
  }

  const bidWayDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '招标方式'
    },
    descriptionContent: bidWayDescContent
  })

  const tableHead = [
    { content: '序号', width: '30px' },
    { content: '材料名称', width: '100px' },
    { content: '材料类型', width: '100px' },
    { content: '是否必填', width: '100px' },
    { content: '填写说明' }
  ]
  let tableBody = []
  if (orderInfo.otherMaterialList && orderInfo.otherMaterialList.length) {
    tableBody = orderInfo.otherMaterialList.map((value, index) => {
      return [
        { content: index + 1 },
        { content: value.materialName || '-' },
        {
          content:
            otherMaterialTypeDict.translate(value?.materialType).label || '-'
        },
        {
          content:
            otherMaterialRequirementDict.translate(value?.isRequired).label ||
            '-'
        },
        { content: value?.remark || '-' }
      ].filter(value => value)
    })
  }
  let materialTableHtml = ''
  // 其他材料要求
  if (tableBody && tableBody.length) {
    materialTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: tableHead },
      tableData: tableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }

  // 内部文件
  const internalAttachments = []
  if (orderInfo.internalAttachments && orderInfo.internalAttachments.length) {
    for (let i = 0; i < orderInfo.internalAttachments.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.internalAttachments[i]
      })
      internalAttachments.push(_data.data[0].attachmentInfo.fileName)
    }
  }

  // 联合体报名
  const consortiumDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionContent: [
      {
        label: '联合体报名',
        content: isComboDict.translate(orderInfo?.isCombo).label || '-'
      },
      {
        label: '内部文件',
        content: internalAttachments.join('、') || '-',
        span: 3
      }
    ]
  })

  // 招标文件
  const biddingAttachmentIds = []
  if (orderInfo.biddingAttachmentIds && orderInfo.biddingAttachmentIds.length) {
    for (let i = 0; i < orderInfo.biddingAttachmentIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.biddingAttachmentIds[i]
      })
      biddingAttachmentIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }
  const otherAttachmentIds = []
  if (orderInfo.otherAttachmentIds && orderInfo.otherAttachmentIds.length) {
    for (let i = 0; i < orderInfo.otherAttachmentIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.otherAttachmentIds[i]
      })
      otherAttachmentIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }
  const bidFileDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '招标文件'
    },
    descriptionContent: [
      {
        label: '在线开评标',
        content: whetherDict.translate(orderInfo?.isKpbProject).label || '-'
      },
      {
        label: '上传招标文件',
        content:
          uploadBiddingFileTypeDict.translate(orderInfo?.isReissueFile).label ||
          '-'
      },
      {
        label: '标书费',
        content: [
          {
            content: (strToThousands(orderInfo?.bookFee) || '') + '元'
          },
          {
            content: moneyInCn(orderInfo?.bookFee),
            contentStyle: 'color: red;'
          }
        ]
      },
      {
        label: '上传文件',
        content: biddingAttachmentIds.join('、') || '-',
        span: 3
      },
      {
        label: '其他文件',
        content: otherAttachmentIds.join('、') || '-',
        span: 3
      }
    ]
  })

  // 保证金设置
  const securityDepositDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '保证金设置'
    },
    descriptionContent: [
      {
        label: '是否收取保证金',
        content:
          needBidBondDict.translate(orderInfo?.guarantee?.isCollectGuarantee)
            .label || '-'
      }
    ]
  })

  // 公告
  const noticeContent = await richText(orderInfo?.content)
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '公告'
    },
    descriptionContent: ''
  })

  // 公告标题及正文
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: orderInfo?.title,
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )
  const HTML =
    bidInfoDesc +
    bidWayDesc +
    materialTableHtml +
    consortiumDesc +
    bidFileDesc +
    securityDepositDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)

  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 招标-邀请函
async function bidInvitation(orderId, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.orderName
    ? orderInfo.orderName + '-' + '邀请函'
    : '邀请函'

  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)

  // 内部文件
  const internalAttachments = []
  if (orderInfo.internalAttachments && orderInfo.internalAttachments.length) {
    for (let i = 0; i < orderInfo.internalAttachments.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.internalAttachments[i]
      })
      internalAttachments.push(_data.data[0].attachmentInfo.fileName)
    }
  }

  // 招标方式
  const bidWayDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '招标方式'
    },
    descriptionContent: [
      {
        label: '招标方式',
        content:
          bidInviteWayDict.translate(orderInfo?.biddingMethod).label || '-'
      },
      {
        label: '发布方式',
        content:
          bidPublishWayDict.translate(orderInfo?.releaseMethod).label || '-'
      },
      {
        label: '联合体报名',
        content: isComboDict.translate(orderInfo?.isCombo).label || '-'
      },
      {
        label: '内部文件',
        content: internalAttachments.join('、') || '-',
        span: 3
      },
      {
        label: '供应商',
        content: ''
      }
    ]
  })

  const tableHead = [
    { content: '序号', width: '30px' },
    { content: '供应商名称', width: '200px' },
    { content: '联系人', width: '100px' },
    { content: '联系电话', width: '100px' },
    { content: '联合体其他成员' }
  ]
  let tableBody = []
  if (orderInfo.inviteSup && orderInfo.inviteSup.length) {
    tableBody = orderInfo.inviteSup.map((value, index) => {
      return [
        { content: index + 1 },
        { content: value?.supplierName || '-' },
        {
          content: value?.contactUserName || '-'
        },
        {
          content: value?.contactUserPhone || '-'
        },
        { content: value?.comboCompanyNames || '-' }
      ].filter(value => value)
    })
  }

  let supplierTableHtml = ''
  // 其他材料要求
  if (tableBody && tableBody.length) {
    supplierTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: tableHead },
      tableData: tableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }

  // 招标文件
  const biddingAttachmentIds = []
  if (orderInfo.biddingAttachmentIds && orderInfo.biddingAttachmentIds.length) {
    for (let i = 0; i < orderInfo.biddingAttachmentIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.biddingAttachmentIds[i]
      })
      biddingAttachmentIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }
  const otherAttachmentIds = []
  if (orderInfo.otherAttachmentIds && orderInfo.otherAttachmentIds.length) {
    for (let i = 0; i < orderInfo.otherAttachmentIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.otherAttachmentIds[i]
      })
      otherAttachmentIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }
  const bidFileDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '招标文件'
    },
    descriptionContent: [
      {
        label: '在线开评标',
        content: whetherDict.translate(orderInfo?.isKpbProject).label || '-'
      },
      {
        label: '上传招标文件',
        content:
          uploadBiddingFileTypeDict.translate(orderInfo?.isReissueFile).label ||
          '-'
      },
      {
        label: '标书费',
        content: [
          {
            content: strToThousands(orderInfo?.bookFee) || '' + '元'
          },
          {
            content: moneyInCn(orderInfo?.bookFee),
            contentStyle: 'color: red'
          }
        ]
      },
      {
        label: '上传文件',
        content: biddingAttachmentIds.join('、') || '-',
        span: 3
      },
      {
        label: '其他文件',
        content: otherAttachmentIds.join('、') || '-',
        span: 3
      }
    ]
  })

  // 保证金设置
  const securityDepositDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '保证金设置'
    },
    descriptionContent: [
      {
        label: '是否收取保证金',
        content:
          needBidBondDict.translate(orderInfo?.guarantee?.isCollectGuarantee)
            .label || '-'
      }
    ]
  })

  // 邀请函
  const invitationLetterDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '邀请函'
    },
    descriptionContent: []
  })
  // 邀请函内容
  const noticeContent = await richText(orderInfo?.content)
  const invitationLetterContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: orderInfo.title || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )

  const HTML =
    bidInfoDesc +
    bidWayDesc +
    supplierTableHtml +
    bidFileDesc +
    securityDepositDesc +
    invitationLetterDesc +
    invitationLetterContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 招标-变更公告
async function bidChange(orderId, requestQuery, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.orderName
    ? orderInfo.orderName + '-' + '变更公告'
    : '变更公告'

  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)

  // 内容变更
  const _changeData = await getChangeInfoByIdApi(orderId, requestQuery.changeId)
  const changeInfo = _changeData.data || {}
  const changeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '内容变更'
    },
    descriptionContent: [
      {
        label: '报名时间',
        content: `${changeInfo?.signUpStartTime ||
          '-'}~${changeInfo?.signUpEndTime || '-'}`
      },
      {
        label: '开标时间',
        content: changeInfo?.openTime || '-'
      }
    ]
  })

  // 变更公告
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '变更公告'
    },
    descriptionContent: []
  })

  const content = await richText(changeInfo?.content)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: changeInfo.title || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: content || '-',
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )

  const HTML =
    bidInfoDesc +
    changeContentDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 招标-文件澄清
async function bidClarify(businessInfo, orderId, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.orderName
    ? orderInfo.orderName + '-' + '招标文件澄清'
    : '招标文件澄清'

  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)

  // 文件澄清
  let bidClarifyInfo = {}
  let fileName = ''
  let supplementRemark = ''
  try {
    const _data = await getWorkflowAuditWorkflowDetailApi(workflowId)
    if (_data?.data?.customVariables?.supplementId) {
      const _FileData = await getClarificationByIdApi(
        orderId,
        _data.data.customVariables.supplementId
      )
      bidClarifyInfo = _FileData.data || {}
      supplementRemark = await richText(bidClarifyInfo.supplementRemark)
      if (bidClarifyInfo?.biddingFileId) {
        const _fileGroupIdData = await getFileListByFileIdsApi({
          attachmentId: bidClarifyInfo.biddingFileId
        })
        fileName = _fileGroupIdData?.data[0]?.attachmentInfo?.fileName || '-'
      }
    }
  } catch (error) {
    this.$message.error(error.message)
  }
  const bidClarifyDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '文件澄清'
    },
    descriptionContent: [
      {
        label: '开标时间',
        span: 1,
        content: bidClarifyInfo?.openTime || '-'
      },
      {
        label: '澄清文件',
        span: 2,
        content: fileName || '-'
      },
      {
        label: '澄清声明',
        span: 3,
        content: ''
      },
      {
        label: '',
        content: supplementRemark || '-',
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )

  const HTML =
    bidInfoDesc +
    bidClarifyDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 招标-候选公示
async function bidCandidate(orderId, requestQuery, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.orderName
    ? orderInfo.orderName + '-' + '候选公示'
    : '候选公示'

  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)

  // 中标候选人
  const _candidateData = await fetchCandidateApi(
    orderId,
    requestQuery.candidateId
  )
  const candidateInfo = _candidateData.data || {}
  const candidateDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '中标候选人'
    },
    descriptionContent: [
      {
        label: '中标方式',
        span: 1,
        content: bidWinWayDict.translate(orderInfo?.winType).label || '-'
      },
      {
        label: '报价方式',
        span: 2,
        content: offerTypeDict.translate(orderInfo?.offerType).label || '-'
      }
    ]
  })
  const tableHead = [
    { content: '排名', width: '30px' },
    { content: '供应商名称', width: '300px' },
    { content: '中标价(元)', width: '100px' },
    { content: '备注' }
  ]
  let tableBody = []
  if (candidateInfo?.supplierList && candidateInfo.supplierList.length) {
    tableBody = candidateInfo.supplierList.map((value, index) => {
      return [
        { content: index + 1 },
        { content: value?.supplierName || '-' },
        {
          content: [
            {
              content: value.price ? strToThousands(value?.price) : '-'
            },
            {
              content: `${moneyInCn(value?.price)}`,
              style: 'color: red;'
            }
          ]
        },
        {
          content: value?.remark || '-'
        }
      ].filter(value => value)
    })
  }
  let supplierTableHtml = ''
  // 候选供应商
  if (tableBody && tableBody.length) {
    supplierTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: tableHead },
      tableData: tableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }

  // 招标文件
  const candidateFileIds = []
  if (candidateInfo.candidateFileIds && candidateInfo.candidateFileIds.length) {
    for (let i = 0; i < candidateInfo.candidateFileIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.otherAttachmentIds[i]
      })
      candidateFileIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }
  // 中标候选人公示信息
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '招标候选人公示信息'
    },
    descriptionContent: [
      {
        label: '是否对外发布',
        span: 1,
        content:
          bidPublishAuctionDict.translate(candidateInfo?.isPublicity).label ||
          ''
      },
      {
        label: '上传附件',
        span: 2,
        content: candidateFileIds.join('、') || '-'
      },
      {
        label: '公示标题',
        content: candidateInfo?.title || '-',
        span: 3
      },
      {
        label: '公示内容',
        content: '',
        span: 3
      }
    ]
  })

  const content = await richText(candidateInfo?.content)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: candidateInfo?.title || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: content,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )

  const HTML =
    bidInfoDesc +
    candidateDesc +
    supplierTableHtml +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 招标-成交结果
async function bidClinch(orderId, requestQuery, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.orderName
    ? orderInfo.orderName + '-' + '成交结果'
    : '成交结果'

  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)

  // 中标人
  const _winBidData = await fetchWinBidApi(orderId, requestQuery.winnerId)
  const winBidInfo = _winBidData.data || {}
  const winBidDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '中标候选人'
    },
    descriptionContent: [
      {
        label: '中标方式',
        span: 1,
        content: bidWinWayDict.translate(orderInfo?.winType).label || '-'
      },
      {
        label: '报价方式',
        span: 2,
        content: offerTypeDict.translate(orderInfo?.offerType).label || '-'
      }
    ]
  })
  const tableHead = [
    { content: '排名', width: '30px' },
    { content: '供应商名称', width: '300px' },
    { content: '中标价(元)', width: '100px' },
    { content: '备注' }
  ]
  let tableBody = []
  if (winBidInfo.supplierList && winBidInfo.supplierList.length) {
    tableBody = winBidInfo.supplierList.map((value, index) => {
      const price = `${strToThousands(value?.price)} (${moneyInCn(
        value?.price
      )}) `
      return [
        { content: index + 1 },
        { content: value.supplierName || '-' },
        {
          content: price || '-'
        },
        {
          content: value.remark || '-'
        }
      ].filter(value => value)
    })
  }
  let supplierTableHtml = ''
  // 成交供应商
  if (tableBody && tableBody.length) {
    supplierTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: tableHead },
      tableData: tableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }
  const winnerOtherFileIds = []
  if (winBidInfo?.winnerOtherFileIds) {
    const _data = await getFileListByFileIdsApi({
      attachmentId: winBidInfo.winnerOtherFileIds
    })
    winnerOtherFileIds.push(_data.data[0].attachmentInfo.fileName)
  }
  const fileDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: '',
    descriptionContent: [
      {
        label: '上传附件',
        span: 3,
        content: winnerOtherFileIds.join('、') || '-'
      }
    ]
  })

  // 中标结果通知
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '招标候选人公示信息'
    },
    descriptionContent: [
      {
        label: '是否对外发布',
        span: 1,
        content:
          bidPublishAuctionDict.translate(winBidInfo?.isPublicity).label || ''
      },
      {
        label: '上传附件',
        span: 2,
        content: winnerOtherFileIds.join('、') || '-'
      },
      {
        label: '公示标题',
        content: winBidInfo?.title || '-',
        span: 3
      },
      {
        label: '公示内容',
        content: '',
        span: 3
      }
    ]
  })

  const content = await richText(winBidInfo?.content)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: winBidInfo.title || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: content,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo.flowListing
  )

  const HTML =
    bidInfoDesc +
    winBidDesc +
    supplierTableHtml +
    fileDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 招标-流标公告
async function bidLoss(orderId, requestQuery, workflowId) {
  const _data = await fetchInviteBidDetailApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.orderName
    ? orderInfo.orderName + '-' + '流标公告'
    : '流标公告'

  // 招标信息
  const bidInfoDesc = bidInfoDescription(orderInfo, pdfTitle)

  const _closeData = await getAuctionByIdApi(orderId, requestQuery.closeId)
  const closeInfo = _closeData.data || {}

  const closeInfoDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '流标处理'
    },
    descriptionContent: [
      {
        label: '是否对外发布',
        content:
          bidPublishAuctionDict.translate(closeInfo?.isPublicity).label || ''
      },
      {
        label: '流标状态',
        content:
          bidAuctionStatusDict.translate(closeInfo?.closeStatus).label || ''
      },
      {
        label: '流标原因',
        content: flowMarkDict.translate(closeInfo?.closeReason).label || ''
      }
    ]
  })

  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '流标公告'
    },
    descriptionContent: [
      {
        label: '公示标题',
        content: closeInfo?.title,
        span: 3
      },
      {
        label: '公示内容',
        content: ''
      }
    ]
  })

  const content = await richText(closeInfo?.content)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: closeInfo.title || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: content,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo.flowListing
  )

  const HTML =
    bidInfoDesc +
    closeInfoDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 询比-采购公告
async function inquiryProcurement(orderId, requestQuery, workflowId) {
  const _data = await getInquiryOrderApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.order?.orderName
    ? orderInfo?.order?.orderName + '-' + '采购公告'
    : '采购公告'

  // 询比单信息
  const inquiryDesc = inquiryDescription(orderInfo.order, pdfTitle)

  // 采购清单
  const bidListDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '采购清单'
    },
    descriptionContent: []
  })
  // 表格模板处理
  const columnConfig = await setColumnConfig(orderInfo?.itemSchemaList)
  const {
    purchaseSpecifyConfig,
    supplierResponseConfig
  } = await setTableConfig(columnConfig)

  const tableHead = [
    { content: '序号', width: '30px' },
    { content: '品目信息', width: '100px' },
    { content: '采购量/计量单位', width: '100px' },
    { content: '参数型号', width: '100px' },
    { content: '预算单价(元)', width: '100px' },
    { content: '预算总价(元)', width: '100px' },
    { content: '采购人指定', width: '100px' }, // 采购人指定和供应商指定为自定义配置字段
    { content: '供应商响应', width: '100px' },
    { content: '对供应商备注', width: '100px' },
    { content: '内部备注', width: '100px' },
    { content: '附件', width: '100px' }
  ]

  let tableBody = []
  if (orderInfo?.materielList && orderInfo?.materielList?.length) {
    tableBody = await materielListHandle(
      orderInfo.materielList,
      purchaseSpecifyConfig,
      supplierResponseConfig
    )
  }

  let materialTableHtml = ''
  if (tableBody && tableBody.length) {
    materialTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: tableHead },
      tableData: tableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }
  const totalFee = await getTotalFee(orderInfo?.materielList)
  const totalFeeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: ''
    },
    descriptionContent: [
      {
        label: '全部采购项目总价汇总',
        content: [
          {
            content: strToThousands(totalFee) || '-'
          },
          {
            content: moneyInCn(totalFee) || '-',
            contentStyle: 'color: red'
          }
        ]
      }
    ]
  })

  // 对供应商要求
  const requirementDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '对供应商要求'
    },
    descriptionContent: [
      {
        label: '报价截止时间',
        content: orderInfo?.order?.offerEndTime || '-'
      },
      {
        label: '采购类型',
        content:
          inquiryProcureTypeDict.translate(orderInfo?.order?.purchaseType)
            .label || '-'
      },
      {
        label: '报价含税',
        content:
          inquiryRequireTaxDict.translate(orderInfo?.order?.offerAllowPart)
            .label || '-'
      },
      {
        label: '允许对部分品目报价',
        content:
          inquiryAllowPartDict.translate(orderInfo?.order?.offerAllowPart)
            .label || '-'
      },
      {
        label: '平台使用费',
        content: [
          {
            content: strToThousands(orderInfo?.order?.signUpFee) || '-'
          },
          {
            content: moneyInCn(orderInfo?.order?.signUpFee) || '-',
            contentStyle: 'color: red'
          }
        ]
      },
      {
        label: '保证金',
        content: [
          {
            content: strToThousands(orderInfo?.order?.guaranteeFee) || '-'
          },
          {
            content: moneyInCn(orderInfo?.order?.guaranteeFee) || '-',
            contentStyle: 'color: red'
          }
        ]
      },
      {
        label: '报价单要求在线签章',
        span: 1,
        content:
          whetherSignatureDict.translate(
            orderInfo?.order?.quotationElectronicSignature
          ).label || '-'
      },
      {
        label: '报价附件要求在线签章',
        span: 2,
        content:
          whetherSignatureDict.translate(
            orderInfo?.order?.quotationAccessoryElectronicSignature
          ).label || '-'
      }
    ]
  })

  // 内部文件
  const internalAttachmentIds = []
  if (orderInfo?.order?.internalAttachmentIds && orderInfo?.order?.internalAttachmentIds.length) {
    for (let i = 0; i < orderInfo.order.internalAttachmentIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.order.internalAttachmentIds[i]
      })
      internalAttachmentIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }

  // 询比方式
  const inquiryMethodsDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '询比方式'
    },
    descriptionContent: [
      {
        label: '询比方式',
        content:
          inquiryWayDict.translate(orderInfo?.order?.inquiryType).label || '-'
      },
      {
        label: '公开方式',
        content:
          projectOpenScopeDict.translate(orderInfo?.order?.openScope).label ||
          '-'
      },
      {
        label: '报名审核',
        content:
          inquiryNeedReviewDict.translate(orderInfo?.order?.checkType).label ||
          '-'
      },
      {
        label: '比价方式',
        content:
          inquiryCompareWayDict.translate(orderInfo?.order?.checkType).label ||
          '-'
      },
      {
        label: '内部文件',
        content: internalAttachmentIds.join('、') || '-',
        span: 3
      }
    ]
  })
  // 询比文件
  const _inquiryFileData = await getFileListByGroupIdApi({
    groupId: orderInfo?.order?.inquiryFileGroupId
  })
  const inquiryFileGroupName =
    _inquiryFileData?.data[0]?.attachmentInfo?.fileName || '-'
  const inquiryFileDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '询比文件'
    },
    descriptionContent: [
      {
        label: '询比文件',
        content: inquiryFileGroupName
      }
    ]
  })

  // 公告
  const noticeContent = await richText(orderInfo?.order?.noticeContent)
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '公告'
    },
    descriptionContent: []
  })

  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: orderInfo?.order?.noticeTitle || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )
  const HTML =
    inquiryDesc +
    bidListDesc +
    materialTableHtml +
    totalFeeDesc +
    requirementDesc +
    inquiryMethodsDesc +
    inquiryFileDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 询比-邀请函
async function inquiryInvitation(orderId, requestQuery, workflowId) {
  const _data = await getInquiryOrderApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.order?.orderName
    ? orderInfo?.order?.orderName + '-' + '邀请函公告'
    : '邀请函公告'
  // 询比单信息
  const inquiryDesc = inquiryDescription(orderInfo?.order, pdfTitle)

  // 采购清单
  const bidListDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '采购清单'
    },
    descriptionContent: []
  })
  // 表格模板处理
  const columnConfig = await setColumnConfig(orderInfo?.itemSchemaList)
  const {
    purchaseSpecifyConfig,
    supplierResponseConfig
  } = await setTableConfig(columnConfig)

  const tableHead = [
    { content: '序号', width: '30px' },
    { content: '品目信息', width: '100px' },
    { content: '采购量/计量单位', width: '100px' },
    { content: '参数型号', width: '100px' },
    { content: '预算单价(元)', width: '100px' },
    { content: '预算总价(元)', width: '100px' },
    { content: '采购人指定', width: '100px' }, // 采购人指定和供应商指定为自定义配置字段
    { content: '供应商响应', width: '100px' },
    { content: '对供应商备注', width: '100px' },
    { content: '内部备注', width: '100px' },
    { content: '附件', width: '100px' }
  ]
  let tableBody = []
  if (orderInfo?.materielList && orderInfo?.materielList.length) {
    tableBody = await materielListHandle(
      orderInfo?.materielList,
      purchaseSpecifyConfig,
      supplierResponseConfig
    )
  }
  let materialTableHtml = ''
  if (tableBody && tableBody.length) {
    materialTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: tableHead },
      tableData: tableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }

  const totalFee = await getTotalFee(orderInfo?.materielList)
  const totalFeeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: ''
    },
    descriptionContent: [
      {
        label: '全部采购项目总价汇总',
        content: [
          {
            content: strToThousands(totalFee) || '-'
          },
          {
            content: moneyInCn(totalFee) || '-',
            contentStyle: 'color: red'
          }
        ]
      }
    ]
  })

  // 对供应商要求
  const requirementDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '对供应商要求'
    },
    descriptionContent: [
      {
        label: '报价截止时间',
        content: orderInfo?.order?.offerEndTime || '-'
      },
      {
        label: '采购类型',
        content:
          inquiryProcureTypeDict.translate(orderInfo?.order?.purchaseType)
            .label || '-'
      },
      {
        label: '报价含税',
        content:
          inquiryRequireTaxDict.translate(orderInfo?.order?.offerAllowPart)
            .label || '-'
      },
      {
        label: '允许对部分品目报价',
        content:
          inquiryAllowPartDict.translate(orderInfo?.order?.offerAllowPart)
            .label || '-'
      },
      {
        label: '平台使用费',
        content: [
          {
            content: strToThousands(orderInfo?.order?.signUpFee) || '-'
          },
          {
            content: moneyInCn(orderInfo?.order?.signUpFee) || '-',
            contentStyle: 'color: red'
          }
        ]
      },
      {
        label: '保证金',
        content: [
          {
            content: strToThousands(orderInfo?.order?.guaranteeFee) || '-'
          },
          {
            content: moneyInCn(orderInfo?.order?.guaranteeFee) || '-',
            contentStyle: 'color: red'
          }
        ]
      },
      {
        label: '报价单要求电子签章',
        span: 1,
        content:
          whetherSignatureDict.translate(
            orderInfo?.order?.quotationElectronicSignature
          ).label || '-'
      },
      {
        label: '报价附件要求电子签章',
        span: 2,
        content:
          whetherSignatureDict.translate(
            orderInfo?.order?.quotationAccessoryElectronicSignature
          ).label || '-'
      }
    ]
  })

  // 内部文件
  const internalAttachmentIds = []
  if (orderInfo?.order?.internalAttachmentIds && orderInfo?.order?.internalAttachmentIds.length) {
    for (let i = 0; i < orderInfo.order.internalAttachmentIds.length; i++) {
      const _data = await getFileListByFileIdsApi({
        attachmentId: orderInfo.order.internalAttachmentIds[i]
      })
      internalAttachmentIds.push(_data.data[0].attachmentInfo.fileName)
    }
  }

  // 询比方式
  const inquiryMethodsDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '询比方式'
    },
    descriptionContent: [
      {
        label: '询比方式',
        span: 1,
        content:
          inquiryWayDict.translate(orderInfo?.order?.inquiryType).label || '-'
      },
      {
        label: '比价方式',
        span: 2,
        content:
          inquiryCompareWayDict.translate(orderInfo?.order?.checkType).label ||
          '-'
      },
      {
        label: '内部文件',
        content: internalAttachmentIds.join('、') || '-',
        span: 3
      },
      {
        label: '供应商',
        span: 1,
        content: ''
      }
    ]
  })
  // 供应商
  const supplierTableHead = [
    { content: '序号', width: '30px' },
    { content: '供应商名称', width: '100px' },
    { content: '联系人', width: '100px' },
    { content: '联系电话', width: '100px' }
  ]
  let SupplierTableBody = []
  if (orderInfo?.inviteList && orderInfo?.inviteList.length) {
    SupplierTableBody = orderInfo.inviteList.map((value, index) => {
      return [
        { content: index + 1 },
        { content: value?.supplierName || '-' },
        {
          content: value?.contactUserName || '-'
        },
        {
          content: value?.contactUserPhone || '-'
        }
      ].filter(value => value)
    })
  }
  let SupplierMaterialTableHtml = ''
  // 其他材料要求
  if (SupplierTableBody && SupplierTableBody.length) {
    SupplierMaterialTableHtml = generateTableHtml({
      pdfTitle: '',
      describeInfoTop: [],
      tableHead: { fixedPrev: supplierTableHead },
      tableData: SupplierTableBody,
      needHtmlWrapper: false,
      needPageWrapper: false
    })
  }

  // 询比文件
  const _inquiryFileData = await getFileListByGroupIdApi({
    groupId: orderInfo?.order?.inquiryFileGroupId
  })
  const inquiryFileGroupName =
    _inquiryFileData?.data[0]?.attachmentInfo?.fileName || '-'
  const inquiryFileDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '询比文件'
    },
    descriptionContent: [
      {
        label: '询比文件',
        content: inquiryFileGroupName
      }
    ]
  })

  // 公告
  const noticeContent = await richText(orderInfo?.order?.noticeContent)
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '公告'
    },
    descriptionContent: []
  })

  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: orderInfo?.order?.noticeTitle || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo.flowListing
  )
  const HTML =
    inquiryDesc +
    bidListDesc +
    materialTableHtml +
    totalFeeDesc +
    requirementDesc +
    inquiryMethodsDesc +
    SupplierMaterialTableHtml +
    inquiryFileDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 询比-变更公告
async function inquiryChange(orderId, requestQuery, workflowId) {
  const _data = await getInquiryOrderApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.order?.orderName
    ? orderInfo?.order?.orderName + '-' + '变更公告'
    : '变更公告'

  // 询比单信息
  const inquiryDesc = inquiryDescription(orderInfo?.order, pdfTitle)

  // 内容变更
  const changeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '内容变更'
    },
    descriptionContent: [
      {
        label: '报价截止时间',
        content: orderInfo.order.offerEndTime || '-'
      }
    ]
  })

  const _changeNoticeData = await getNewestChangeInfoApi(orderId)
  const changeNotice = _changeNoticeData.data || {}
  // 公告
  const noticeContent = await richText(changeNotice?.noticeContent)

  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '变更内容'
    },
    descriptionContent: [
      {
        label: '变更内容标题',
        span: 3,
        content: changeNotice?.noticeTitle || '-'
      },
      {
        label: '变更公告内容',
        span: 3,
        content: ''
      }
    ]
  })

  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: changeNotice?.noticeTitle || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })
  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo.flowListing
  )
  const HTML =
    inquiryDesc +
    changeContentDesc +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 询比-候选公示
async function inquiryCandidate(orderId, requestQuery, workflowId, isWuling) {
  const _data = await getInquiryOrderApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.order?.orderName
    ? orderInfo.order.orderName + '-' + '候选公告'
    : '候选公告'

  // 询比单信息
  const inquiryDesc = inquiryDescription(orderInfo?.order, pdfTitle)

  // 获取候选信息
  const _candidateData = await getNewestCandidateInfoApi({ orderId: orderId })
  const candidateInfo = _candidateData.data || {}

  // 流标处理
  const canDidateDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '候选供应商'
    },
    descriptionContent: []
  })

  const spplierTableHtml = await supplierTableHandle(
    orderInfo.itemSchemaList,
    candidateInfo.detailDtoList,
    '候选供应商',
    isWuling
  )

  // 取消品目的列表
  const cancelTableHtml = await getCandidateCancelHtmlData({
    itemSchemaList: orderInfo.itemSchemaList,
    cancelList: candidateInfo.cancelList,
    cancelReason: candidateInfo.cancelReason,
    cancelAttachmentIds: candidateInfo.cancelAttachmentIds,
    isDollar: orderInfo.isDollar
  })
  const cancelHtml = generateDescriptionHtml({
    descriptionTitle: {
      content: '候选供应商'
    },
    descriptionContent: cancelTableHtml
  })

  // 候选供应商公示
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '候选供应商公示'
    },
    descriptionContent: [
      {
        label: '发布公示',
        content:
          inquiryWhetherToPublishDict.translate(candidateInfo?.publicity)
            .label || '-'
      }
    ]
  })
  const noticeContent = await richText(candidateInfo?.noticeContent)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: candidateInfo?.noticeTitle || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })
  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo.flowListing
  )
  const HTML =
    inquiryDesc +
    canDidateDesc +
    spplierTableHtml +
    cancelHtml +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 询比-成交结果
async function inquiryClinch(orderId, requestQuery, workflowId, isWuling) {
  const _data = await getInquiryOrderApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.order?.orderName
    ? orderInfo?.order?.orderName + '-' + '成交公告'
    : '成交公告'

  // 询比单信息
  const inquiryDesc = inquiryDescription(orderInfo?.order, pdfTitle)
  const isDollar = orderInfo.currencyType === currencyTypeDict.DOLLAR.value

  // 获取成交信息
  const _winnerData = await getNewestWinnerInfoApi({ orderId: orderId })
  const winnerInfo = _winnerData.data || {}

  // 流标处理
  const canDidateDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '成交供应商'
    },
    descriptionContent: []
  })

  const spplierTableHtml = await supplierTableHandle(
    orderInfo?.itemSchemaList,
    winnerInfo?.detailDtoList,
    '成交供应商',
    isWuling
  )

  const bargainHtml = generateDescriptionHtml({
    descriptionTitle: { content: '议价' },
    descriptionContent: await generateBargainHtml(winnerInfo, isDollar)
  })

  // 成交供应商结果公告
  const noticeDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '成交供应商结果公告'
    },
    descriptionContent: [
      {
        label: '发布公告',
        content:
          inquiryWhetherToPublishDict.translate(winnerInfo?.publicity).label ||
          '-'
      }
    ]
  })
  const noticeContent = await richText(winnerInfo.noticeContent)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: winnerInfo.noticeTitle || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })
  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )
  const HTML =
    inquiryDesc +
    canDidateDesc +
    spplierTableHtml +
    bargainHtml +
    noticeDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 询比-流标公告
async function inquiryLoss(orderId, requestQuery, workflowId) {
  const _data = await getInquiryOrderApi({ orderId: orderId })
  const orderInfo = _data.data || {}
  const pdfTitle = orderInfo?.order?.orderName
    ? orderInfo?.order?.orderName + '-' + '流标公告'
    : '流标公告'

  // 询比单信息
  const inquiryDesc = inquiryDescription(orderInfo?.order, pdfTitle)

  const _lossData = await inquiryAbortiveInfoApi(orderId)
  const lossContent = _lossData.data || {}

  // 流标处理
  const lossDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: '流标处理'
    },
    descriptionContent: [
      {
        label: '流标原因',
        content: flowMarkDict.translate(lossContent?.closeReason).label || '-'
      },
      {
        label: '发布流标公告',
        content:
          inquiryWhetherToPublishDict.translate(lossContent?.closePublicity)
            .label || '-'
      },
      {
        label: '流标公告标题',
        content: lossContent?.notice?.noticeTitle || '-'
      },
      {
        label: '流标公告内容',
        span: 3,
        content: ''
      }
    ]
  })

  // 公告
  const noticeContent = await richText(lossContent?.notice?.noticeContent)
  const noticeContentDesc = generateDescriptionHtml({
    pdfTitle: '',
    descriptionTitle: {
      content: lossContent?.notice?.noticeTitle || '-',
      style: 'width:100%;text-align: center;font-size: 20px;font-weight: bold;'
    },
    descriptionContent: [
      {
        label: '',
        content: noticeContent,
        span: 3,
        contentStyle: 'text-indent: 2em;line-height: 16px;'
      }
    ]
  })

  const auditRemarksDesc = await auditRemarksHandle(workflowId)

  const { auditHistoryDesc, auditHistoryTableHtml } = await auditHistoryHandle(
    orderInfo?.flowListing
  )
  const HTML =
    inquiryDesc +
    lossDesc +
    noticeContentDesc +
    auditRemarksDesc +
    auditHistoryDesc +
    auditHistoryTableHtml

  const pdfTitleStr = await stripscript(pdfTitle)
  const tableHtmlWrapperHTML = tableHtmlWrapper(HTML, pdfTitleStr)

  downloadPdf(tableHtmlWrapperHTML, pdfTitle)
}

// 下载pdf文件
async function downloadPdf(content, name) {
  const postData = {
    name: name + '.pdf',
    watermark: {
      watermarkType: watermarkTypeDict.ORDINARY_TEXT.value, // 水印类型
      watermarkWord: '精彩纵横云采购平台'
    },
    content: content
  }
  htmlToPdfApi(postData)
    .then(res => {
      getFileUrlByFileIdApi({ attachmentId: res.data }).then(fileRes => {
        window.open(fileRes.data.external, '_self')
      })
    })
    .catch(err => {
      if (err?.message) this.$message.error(err.message)
      throw err
    })
}

// 处理审批备注
async function auditRemarksHandle(workflowId) {
  const _data = await getWorkflowRemarksApi(workflowId)
  const remarkList = _data.data || []

  const descriptionContentData = []
  remarkList.map(item => {
    descriptionContentData.push({
      label: '备注',
      content: item.remark || '-'
    })
    descriptionContentData.push({
      label: '添加审批备注时间',
      content: item.remarkTime || '-'
    })
  })
  const auditRemarksDesc = remarkList.length
    ? generateDescriptionHtml({
      pdfTitle: '',
      descriptionTitle: {
        content: '审批备注'
      },
      descriptionContent: descriptionContentData
    })
    : ''
  return auditRemarksDesc
}

/**
 * 导出Excel
 * @param {*} businessInfo
 * @param {*} orderId
 * @param {*} workflowId
 * @param {*} requestQuery
 */
export function exportEXCEL(businessInfo, orderId, workflowId, requestQuery) {
  if (businessInfo.businessType === 'inquiry') {
    // 询比-成交结果
    if (
      businessInfo.businessNode == 'submit_confirm_winner_supplier' ||
      businessInfo.businessNode == 'submit_modify_winner_supplier'
    ) {
      exportInquiryWinnerApi(orderId, requestQuery, workflowId)
    }
  }
}
